// Dependencies
import React, { Component, PropTypes } from 'react';
import $ from 'jquery';
import { RaisedButton, Paper } from 'material-ui';
import R from 'ramda';
import { connect } from 'react-redux';
// Components
import ListItem from './list-item-partnerFinder';
import Card from '../tc-ui/search-bar-card';
import Icon from '../tc-ui/icon';
import SectionHeading from '../tc-ui/section-heading';
import MultiMarkerMap from '../map-multimarkers';
import languagesObj from '../../localization/languages.json';
const languageSettings = languagesObj['en-US'];
import { getGeoLocation } from '../../utils/address';
import Pagination from '../tc-ui/pagination/pagination';
import GrowNetwork from './grow-network';

// fix for firefox
// const getDocHeight = () => {
//   const D = document;
//   return Math.max(
//     Math.max(D.body.scrollHeight, D.documentElement.scrollHeight),
//     Math.max(D.body.offsetHeight, D.documentElement.offsetHeight),
//     Math.max(D.body.clientHeight, D.documentElement.clientHeight)
//   );
// }

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      view: 'List View',
      isFixed: false,
    };
    this.onScroll = this.onScroll.bind(this);
  }

  componentWillMount() {
    if (!this.props.partnerFinder.results) {
      this.props.search(this.props.partnerFinder.searchParams, undefined, true);
    }
  }

  componentDidMount() {
    if (window.addEventListener) {
      window.addEventListener('scroll', this.onScroll);
    } else {
      window.attachEvent('onscroll', this.onScroll);
    }
  }

  componentWillReceiveProps(props) {
    if (props.partnerFinder.searchParams.companyType === 'Contractor' || props.partnerFinder.searchParams.companyType === 'Other') {
      this.setState({
        view: 'List View',
        infoBoxContent: undefined,
      });
    }
  }

  componentWillUnmount() {
    if (window.addEventListener) {
      window.removeEventListener('scroll', this.onScroll);
    } else {
      window.detachEvent('onScroll', this.onScroll);
    }
    // const searchParams = this.props.partnerFinder.searchParams;
    // searchParams.isForMap = undefined;
    // searchParams.latitude = undefined;
    // searchParams.longitude = undefined;
    // searchParams.radius = undefined;
    // searchParams.page = 1;
    // this.props.search(searchParams, undefined, true);
  }

  onScroll() {
    const { partnerFinder } = this.props;
    const scrollTop = document.body.scrollTop || $('html').scrollTop(); // Firefox doc.body.scrollTop always 0 - so must switch to jquery html

    if (this.state.view === 'Map View') {
      this.setState({ isFixed: false });
    } else if (scrollTop >= 32 !== this.state.isFixed) {
      this.setState({ isFixed: !this.state.isFixed });
    }
    // if (document.body.offsetHeight + scrollTop === getDocHeight()) {
    //   loadMore(partnerFinder.searchParams, true);
    // }
  }

  getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const r = 6371;
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1) * (Math.PI / 180)) * Math.cos((lat2) * (Math.PI / 180)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return r * c;
  }

  _handleViewChange = (value) => {
    this.setState({ view: value, infoBoxContent: undefined });
    let searchParams = this.props.partnerFinder.searchParams;
    if (value === 'Map View') {
      searchParams.isForMap = true;
      getGeoLocation({ city: searchParams.city, country: searchParams.country }, (address, geometry) => {
        const [longitude, latitude] = address.coordinates;
        searchParams = Object.assign({}, searchParams, {
          longitude,
          latitude,
          bounds: geometry.viewport,
          radius: this._calculateRadius([latitude, longitude], geometry.viewport),
        });
        this.props.search(searchParams);
      });
    } else {
      searchParams.isForMap = undefined;
      searchParams.longitude = undefined;
      searchParams.latitude = undefined;
      searchParams.radius = undefined;
      this.props.search(searchParams);
    }
  };

  _handleMapChangeAndSearch = (center, bounds, zoom) => {
    const searchParams = this.props.partnerFinder.searchParams;
    searchParams.latitude = center[0];
    searchParams.longitude = center[1];
    if (bounds) {
      searchParams.bounds = undefined;
      searchParams.radius = this._calculateRadius(center, bounds);
    }
    if (zoom) {
      searchParams.zoom = zoom;
    }
    this.props.search(searchParams);
  };

  _calculateRadius(center, bounds) {
    const radius1 = this.getDistanceFromLatLonInKm(center[0], center[1], bounds.getSouthWest().lat(), bounds.getSouthWest().lng());
    const radius2 = this.getDistanceFromLatLonInKm(center[0], center[1], bounds.getNorthEast().lat(), bounds.getNorthEast().lng());
    return Math.max(radius1, radius2);
  }

  _openInfoBox = (result) => {
    this.setState({
      infoBoxContent: result,
    });
  };

  render() {
    const { partnerFinder, loadMore, searchDefault, lockedPartnersBanner } = this.props;

    const pagination = partnerFinder.total > 10 ? (
      <Pagination
        style={{ backgroundColor: '#fafafa', marginLeft: '-16px' }}
        currentPage={(partnerFinder.searchParams.page || 1)}
        totalPages={Math.ceil((partnerFinder.total || 0) / 10)}
        goToPage={page => loadMore(page)}
        noOfPagesToShow={5}
      />) : <div/>;
    const listItems = (() => {
      if (!partnerFinder.results) return '';
      if (!Array.isArray(partnerFinder.results)) {
        return <div className="no-connections"><h4 className="no-connections-message"> {"Sorry, we did not find any results for your search."}</h4></div>;
      }
      return partnerFinder.results.map((result, index) => {
        result.companyId = result.companyId ? result.companyId : result.supplierId;
        return (<ListItem {...this.props} {...result} key={index} isForPremiumUser={partnerFinder.searchParams.isForPremiumUser}/>);
      });
    })();
    const checkCompanyType = R.call(R.cond([
      [R.equals('Contractor'), R.always('buyers')],
      [R.equals('Supplier'), R.always('suppliers')],
      [R.equals('Other'), R.always('others')],
      [R.T, R.always('companies')],
    ]), partnerFinder.searchParams.companyType);
    const SellingOrIn = checkCompanyType === 'suppliers' || checkCompanyType === 'others' ? 'in' : 'selling';
    const country = partnerFinder.searchParams.country || (partnerFinder.searchParams.destinationsSold ? partnerFinder.searchParams.destinationsSold[0] : 'your search');
    const subtitle = (() => {
      if (this.state.view === 'Map View') return `We found ${partnerFinder.results.length} ${checkCompanyType} in this area that match your search`;
      return `We found ${partnerFinder.total} ${checkCompanyType} ${SellingOrIn} ${country} that match your search.`;
    })();
    const titleBarExtra = (() => {
      if (partnerFinder.searchParams.companyType === 'Supplier') {
        if (this.state.view === 'List View') {
          return (
            <div onClick={this._handleViewChange.bind(this, 'Map View')} style={{ float: 'right', marginTop: '12px', marginRight: '5px' }} className="profile-edit-icon-container top-bar-edit-container">
              <Icon className="tc-icon-map profile-edit-icon" style={{ top: '1px' }} />
              {"Map View"}
            </div>
          );
        } else if (this.state.view === 'Map View') {
          return (
            <div onClick={this._handleViewChange.bind(this, 'List View')} style={{ float: 'right', marginTop: '12px', marginRight: '5px' }} className="profile-edit-icon-container top-bar-edit-container">
              <Icon className="tc-icon-list2 profile-edit-icon" style={{ top: '1px' }} />
              {"List View"}
            </div>
          );
        }
      }
    })();

    const searchBarHintText = languageSettings.partnerFinder.rightContent.searchBarText;
    const bounds = partnerFinder.searchParams.bounds;
    const zoom = partnerFinder.searchParams.zoom;
    const centerCoordinates = partnerFinder.searchParams.latitude ? [partnerFinder.searchParams.latitude, partnerFinder.searchParams.longitude] : undefined;
    let infoBoxForMapView;
    const content = (() => {
      if (this.state.view === 'List View') {
        if (this.props.partnerFinder.status === 'isSyncing') {
          return (
            <div className="no-connections-loading" style={{ width: '100%', height: '100px' }}>
              <div className="load-bar loader"></div>
            </div>
          );
        }
        // if (partnerFinder.threeConnectedCustomers) {
        //   return (
        //     <div className={'connections-list'}>
        //       {listItems}
        //     </div>
        //   );
        // }
        return (
          <div onScroll={this.onScroll} className={'connections-list'}>
            {listItems}
            {pagination}
          </div>
        );
      }
      if (this.state.view === 'Map View') {
        if (this.state.infoBoxContent) {
          // if (partnerFinder.searchParams.isForPremiumUser) {
          const listItemContent = Object.assign({}, this.state.infoBoxContent);
          listItemContent.companyId = listItemContent.companyId || listItemContent.supplierId;
          listItemContent.isForPremiumUser = partnerFinder.searchParams.isForPremiumUser;
          infoBoxForMapView = (
            <Paper style={{ paddingLeft: '15px' }}>
              <ListItem {...this.props} {...listItemContent}/>
            </Paper>
          );
          // } else {
          //   infoBoxForMapView = (
          //     <Paper style={{ textAlign: 'center' }}>
          //       <RaisedButton style={{ margin: '20px auto 20px auto' }} primary label="upgrade my plan" onClick={this._pullOutUpgrade.bind(this, 'down')}/>
          //     </Paper>
          //     );
          // }
        }
        if (Array.isArray(this.props.partnerFinder.results)) {
          return (
            <div style={{ height: '500px', width: '100%' }}>
              <MultiMarkerMap
                onChange={this._handleMapChangeAndSearch.bind(this)}
                bounds={bounds}
                zoom={zoom}
                isForPremiumUser={partnerFinder.searchParams.isForPremiumUser}
                openInfoBox={this._openInfoBox.bind(this)}
                centerCoordinates={centerCoordinates}
                markers={partnerFinder.results}
                googleMapsApi={window.google.maps}
              />
            </div>
          );
        }
        return <div></div>;
      }
    })();
    const searchResultsTitle = (() => {
      if (partnerFinder.searchParams.companyType === 'Supplier') return languageSettings.partnerFinder.rightContent.supplierSearchResultsTitle;
      if (partnerFinder.searchParams.companyType === 'Other') return languageSettings.partnerFinder.rightContent.otherSearchResultsTitle;
      return languageSettings.partnerFinder.rightContent.contractorSearchResultsTitle;
    })();

    return (
        <div style={this.state.position} className="l-left-nav-content transformation">
          {lockedPartnersBanner}
          {
            lockedPartnersBanner ? <br/> : undefined
          }
          {
            partnerFinder.results && partnerFinder.total < 3 ?
              <GrowNetwork history={this.props.history} networkLocation={country} containerStyle={{ marginBottom: '10px' }} /> : <span/>
          }
          <Card
            title={searchResultsTitle}
            subtitle={subtitle}
            isSticky
            isFixed={this.state.isFixed}
            searchHeader
            listCard
            padded={false}
            titleBarExtra={titleBarExtra}
            searchBarHintText={searchBarHintText}
            {...this.props}
            defaultValue={searchDefault}
          >
            {content}
          </Card>
          {infoBoxForMapView}
        </div>
    );
  }
}

List.propTypes = {
  search: PropTypes.func,
  partnerFinder: PropTypes.object,
  searchParams: PropTypes.object,
  loadMore: PropTypes.func,
  router: PropTypes.object,
  history: PropTypes.object,
  searchDefault: PropTypes.string,
};

export default connect(({ partnerFinder }) => ({
  searchDefault: partnerFinder.getIn(['searchParams', 'companyOrLocationName']),
}), {})(List);



// WEBPACK FOOTER //
// ./src/app/components/partner-finder/list-partnerFinder.jsx